module.exports = __webpack_public_path__ + "media/images/download-fce1152fa65ed26290b116d3505178f4.svg";